// extracted by mini-css-extract-plugin
module.exports = {"label":"Stepper_label__1z5ZA","mobile":"Stepper_mobile__2d7kb","root":"Stepper_root__pcumF"};